import { api } from "@/lib/api";

interface SubscriptionResponse {
	success: boolean;
	data: { subscribed: boolean };
}

function base(projectId: string, taskId: string) {
	return `/projects/${projectId}/tasks/${taskId}/subscription`;
}

export async function getSubscription(
	projectId: string,
	taskId: string,
): Promise<boolean> {
	const res = await api.get<SubscriptionResponse>(base(projectId, taskId));
	return res.data.subscribed;
}

export async function subscribe(
	projectId: string,
	taskId: string,
): Promise<boolean> {
	const res = await api.post<SubscriptionResponse>(
		base(projectId, taskId),
		{},
	);
	return res.data.subscribed;
}

export async function unsubscribe(
	projectId: string,
	taskId: string,
): Promise<boolean> {
	const res = await api.delete<SubscriptionResponse>(base(projectId, taskId));
	return res.data.subscribed;
}
